import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IconArrowLeft } from '@tabler/icons-react'
import { useAppDispatch, useAppSelector } from 'store'
import styled from 'styled-components'

import pageNotFoundImage from 'assets/pageNotFound.png'
import { Button } from 'components/atoms/Button'
import { Layout } from 'pages/components/Layout'
import { getUserToken, setUserToken } from 'services/authSlice'
import { PATHS } from 'utils/paths'
import { isNilOrEmpty } from 'utils/ramda'

const NotPermittedPage = () => {
  const navigate = useNavigate()

  const dispatch = useAppDispatch()
  // const userToken = useAppSelector(getUserToken)

  const content = () => {
    return (
      <Wrapper $dashboard={true}>
        <Headline>You do not have permission to view this page.</Headline>
        <Button
          variant='outlined'
          size='medium'
          type='button'
          onClick={() => navigate(PATHS.products)}
          starticon={<IconArrowLeft />}
        >
          {'Take me back to the home page'}
        </Button>
        <Image src={pageNotFoundImage} alt='page not found' />
      </Wrapper>
    )
  }

  return <Layout menuOpenProp={false}>{content()}</Layout>
}

export default NotPermittedPage

const Wrapper = styled.div<{
  $dashboard: boolean
}>`
  width: 100%;
  padding: ${({ $dashboard }) => ($dashboard ? '0' : '60px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
`
const Headline = styled.div`
  font-size: 48px;
  line-height: 120%;
  letter-spacing: -0.5px;
  font-weight: lighter;
  color: ${({ theme }) => theme.colors.primary};
`
const AdditionalInfo = styled.div`
  max-width: 670px;
  text-align: center;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.5px;
  color: ${({ theme }) => theme.colors.primary};
`
const Image = styled.img`
  width: 1116px;
  height: 600px;
`
